import {NgModule} from "@angular/core";
import {CommonModule} from "@angular/common";
import {DatepickerComponent} from "./datepicker.component";
import {TranslateModule} from "@ngx-translate/core";
import {MatIconModule} from "@angular/material/icon";
import {OverlayModule} from "@angular/cdk/overlay";
import {A11yModule} from '@angular/cdk/a11y';

@NgModule({
  declarations: [DatepickerComponent],
  imports: [ CommonModule, TranslateModule, MatIconModule, OverlayModule, A11yModule ],
  exports: [ DatepickerComponent ],
})
export class DatepickerModule {}
